import { z } from "zod";

export const ClaudeConfigSchema = z
  .object({
    /** Root directory for Claude artifacts (relative to the project root). */
    output_dir: z.string().default(".claude"),
    /** Path to agent-contracts.yaml (relative to the project root). */
    config_path: z.string().default("./agent-contracts.yaml"),
    /**
     * Command wired into guardrail hooks (e.g. "dev-team guard evaluate").
     * Reserved for future hook integration; validated for config parity.
     */
    guard_command: z.string().optional(),
    /** Override component id; defaults to `dsl.system.id`. */
    component_id: z.string().optional(),
  })
  .strip();

export type ClaudeConfig = z.infer<typeof ClaudeConfigSchema>;

/** Parse and default-fill an opaque config payload from component.yaml. */
export function parseClaudeConfig(raw: unknown): ClaudeConfig {
  return ClaudeConfigSchema.parse(raw ?? {});
}
